import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { MediaType } from '../MediaType';

export const experimentalAnalyticsActivityByUser: ExperimentalQueries['experimentalAnalyticsActivityByUser'] =
	(
		_,
		{
			cloudId,
			fromDate,
			toDate,
			timezone,
			content,
			spaceId,
			spaceType,
			sortorder,
			sortBy,
			offset,
			limit,
		},
		{ network },
	) => {
		const params = new URLSearchParams({
			fromDate,
			toDate,
			timezone,
			content,
		});
		if (spaceId) {
			params.append('spaceId', spaceId);
		}
		// global | personal
		if (spaceType) {
			params.append('spaceType', spaceType);
		}
		if (offset != undefined) {
			params.append('offset', String(offset));
		}
		if (limit) {
			params.append('limit', String(limit));
		}
		// 'commentCreated'|'created'|'viewed'|'updated'
		if (sortBy) {
			params.append('sortBy', sortBy);
		}
		if (sortorder) {
			params.append('sortOrder', sortorder);
		}

		const url = `/gateway/api/ex/confluence/${cloudId}/analytics/v2/activityByUser?${params.toString()}`;

		return network
			.cfetch(url, {
				method: 'GET',
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			})
			.then((response) => response.json())
			.then((responseJson) => {
				return responseJson;
			});
	};
